import { render } from "./SamplePopup.vue?vue&type=template&id=5aa7ccb9&scoped=true"
import script from "./SamplePopup.vue?vue&type=script&lang=js"
export * from "./SamplePopup.vue?vue&type=script&lang=js"

import "@/assets/css/components/commonPopup_v2.css?vue&type=style&index=0&id=5aa7ccb9&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa7ccb9"]])

export default __exports__